import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGUAGES, getT } from "@/i18n/translations";

const LanguageContext = createContext({ lang: "pt", setLang: () => {}, t: getT("pt") });

const detectInitial = () => {
  try {
    const stored = localStorage.getItem("decrepalma_lang");
    if (stored && LANGUAGES.some((l) => l.code === stored)) return stored;
    const nav = (navigator.language || "pt").slice(0, 2).toLowerCase();
    if (LANGUAGES.some((l) => l.code === nav)) return nav;
  } catch {
    // ignore
  }
  return "pt";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectInitial);

  useEffect(() => {
    try {
      localStorage.setItem("decrepalma_lang", lang);
      document.documentElement.setAttribute("lang", lang);
      const t = getT(lang);
      if (t?.seo?.title) document.title = t.seo.title;
      const desc = document.querySelector('meta[name="description"]');
      if (desc && t?.seo?.description) desc.setAttribute("content", t.seo.description);
    } catch {
      // ignore
    }
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: getT(lang) }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
